import React from 'react';
import { ReactComponent } from 'Common/components/Icons/eye-protection.svg';

const EyeProtection = () => <ReactComponent className="MuiSvgIcon-root" />;

export default EyeProtection;
